export default __webpack_public_path__ + "static/media/6_boatloadOfGems.4c1b4554.png";